import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const services = [
  'Resume Writing',
  'LinkedIn Profile Makeover',
  'LinkedIn Content & Posts',
  'Personal Brand Strategy',
  'Career Messaging & Bio',
];

const Footer = () => (
  <footer className="bg-brand-secondary border-t border-white/10 py-12">
    <div className="container mx-auto px-6 max-w-7xl">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 rounded-xl bg-brand-accent flex items-center justify-center">
              <SafeIcon icon={FiIcons.FiTrendingUp} className="text-brand-secondary text-lg" />
            </div>
            <div>
              <span className="text-white font-extrabold text-base leading-none">Revival Tech Firm</span>
              <p className="text-brand-accent text-xs font-semibold tracking-widest uppercase">Career Branding</p>
            </div>
          </div>
          <p className="text-gray-400 text-sm leading-relaxed">
            Helping career professionals stand out with powerful resumes, optimized LinkedIn profiles, and content that gets results.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Our Services</h4>
          <ul className="space-y-2 text-gray-400 text-sm">
            {services.map((s) => (
              <li key={s}>
                <a
                  href="#services"
                  onClick={(e) => { e.preventDefault(); document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="hover:text-brand-accent transition-colors cursor-pointer"
                >
                  {s}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-3 text-gray-400 text-sm">
            <li className="flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiMail} className="text-brand-accent" />
              <a href="mailto:contact@revivaltechfirm.com" className="hover:text-brand-accent transition-colors">
                contact@revivaltechfirm.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <SafeIcon icon={FiIcons.FiPhone} className="text-brand-accent" />
              <a href="tel:+18322994360" className="hover:text-brand-accent transition-colors">
                (832) 299-4360
              </a>
            </li>
            <li className="flex items-center gap-2">
              <FiIcons.FiLinkedin className="text-[#0077B5] flex-shrink-0" />
              <a
                href="https://www.linkedin.com/in/garyfagerholm/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#0077B5] transition-colors"
              >
                linkedin.com/in/garyfagerholm
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Revival Tech Firm. All rights reserved.</p>
        <p className="text-gray-500 text-sm">Empowering professionals to own their career narrative.</p>
      </div>
    </div>
  </footer>
);

export default Footer;